// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"25cee788","363":"980693e0","433":"9f8fb9f6","453":"89f79772","525":"39632969","819":"2d702a3a","967":"56c535cd"}[chunkId] + ".chunk.js";
};